import { render, staticRenderFns } from "./IconYpoWithText.vue?vue&type=template&id=d4de74e0&scoped=true&"
import script from "./IconYpoWithText.vue?vue&type=script&lang=js&"
export * from "./IconYpoWithText.vue?vue&type=script&lang=js&"
import style0 from "./IconYpoWithText.vue?vue&type=style&index=0&id=d4de74e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4de74e0",
  null
  
)

export default component.exports